import { Settings as SettingsPresenter } from './presenter';
import { connect, quizBuildingSession } from '@instructure/quiz-core';
export var Settings = connect(null, {
  quizBuildingSession: quizBuildingSession
})(SettingsPresenter);
export default Settings;